<script>
import { mapState, mapActions } from 'vuex';
import validatorMixin from '../../mixins/validatorMixin';
import transportTypes from '../../variables/transportTypes';

export default {
  name: 'FerryCabinEdit',
  mixins: [validatorMixin],
  props: {
    shown: {
      type: Boolean,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      validForm: true,
      current: null,
      train: transportTypes.TRAIN,
    };
  },
  computed: {
    ...mapState({
      cabin: state => state.transportation.cabins.cabin,
      saveError: state => state.transportation.cabins.saveError,
      saveLoading: state => state.transportation.cabins.saveLoading,
      personCategories: state => state.transportation.personCategories.items,
      personCategoriesItemsLoading: state => state.transportation.personCategories.itemsLoading,
    }),
    changesMade() {
      const changes = JSON.stringify(this.current) !== JSON.stringify(this.cabin);
      this.$emit('input', changes);
      return changes;
    },
  },
  methods: {
    ...mapActions({
      getPersonCategoriesBySupplier: 'transportation/getPersonCategoriesBySupplier',
      updateCabin: 'transportation/updateCabin',
    }),
    saveEditCabin() {
      if (this.validForm && this.changesMade) {
        this.updateCabin(this.current)
          .then((res) => {
            if (res) {
              this.$emit('close', true);
            }
          });
      }
    },
  },
  watch: {
    shown() {
      if (this.shown) {
        this.current = { ...this.cabin };
        this.$emit('input', this.changesMade);
        this.getPersonCategoriesBySupplier();
      }
    },
  },
};
</script>

<template>
  <v-card v-if="cabin && current">
    <v-form v-model="validForm" @submit.prevent="saveEditCabin">
      <v-card-title>
        <span class="headline">
          Edit Cabin
        </span>
      </v-card-title>

      <v-card-text class="py-0 mb-3 edit-item-status">
        <v-progress-linear
          v-if="saveLoading"
          :active="saveLoading"
          :height="4"
          class="my-0"
          indeterminate
        />
        <v-alert
          v-if="!saveLoading"
          :value="!!saveError"
          class="my-0 py-2"
          transition="slide-y-transition"
          outline
        >
          An error occurred while saving
        </v-alert>
      </v-card-text>

      <v-card-text class="py-0">
        <v-container grid-list-md pt-1>
          <v-layout row>
            <v-flex xs12>
              <v-text-field
                v-model="current.name"
                :rules="[rules.required]"
                :disabled="saveLoading"
                label="Name"
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12>
              <v-text-field
                v-model="current.webName"
                :rules="[rules.required]"
                :disabled="saveLoading"
                label="Name displayed on the website"
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12>
              <v-text-field
                v-model="current.maxPersons"
                :rules="[rules.required]"
                :disabled="saveLoading"
                type="number"
                label="Max persons"
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12>
              <v-text-field
                v-model="current.externalRef"
                :rules="[rules.required]"
                :disabled="saveLoading"
                hint="External ref is used to identify the cabin against suppliers system"
                label="External reference"
              />
            </v-flex>
          </v-layout>

          <v-layout v-if="type === train" row>
            <v-flex xs12>
              <v-select
                v-model="current.ferryPersonCategoryId"
                :items="personCategories"
                :value="current.ferryPersonCategoryId"
                :loading="personCategoriesItemsLoading"
                label="Person category"
                item-text="name"
                item-value="id"
                hide-details
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12>
              <v-checkbox
                v-model="current.active"
                :disabled="saveLoading"
                label="Active"
                class="mt-0"
                hide-details
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn
          @click="$emit('close')"
          color="red darken-1"
          flat
        >
          Close
        </v-btn>
        <v-tooltip :disabled="changesMade" top>
          <template slot="activator" slot-scope="{ on }">
            <div v-on="on">
              <v-btn
                :disabled="!validForm || saveLoading || !changesMade"
                color="blue darken-1"
                type="submit"
                flat
              >
                Save
              </v-btn>
            </div>
          </template>
          <span>
            No changes has been made
          </span>
        </v-tooltip>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<style lang="scss">
  .edit-item-status {
    min-height: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/transportation/TransportationCabinEdit.vue